/* global bootstrap */

export const carousel = {
	init: ( selector = '.wp-block-group.is-slider' ) => {
		let carouselCounter = 0;
		document.querySelectorAll( selector ).forEach( ( carouselElmt ) => {
			const carouselId = 'wpBlockCarousel-' + carouselCounter;
			carouselElmt.setAttribute( 'id', carouselId );
			carouselElmt.classList.add( 'carousel', 'slide' );
			const carouselInner = carouselElmt.querySelector( ':scope > div' );
			carouselInner.classList.add( 'carousel-inner' );
			const items = carouselInner.querySelectorAll( ':scope > div' );
			items.forEach( ( carouselItem, i ) => {
				carouselItem.classList.add( 'carousel-item' );
				if ( i === 0 ) {
					carouselItem.classList.add( 'active' );
				}
			} );

			// Dots / Arrows
			const carouselControlsContainer = document.createElement( 'div' );
			carouselControlsContainer.classList.add( 'controls-wrapper' );
			carouselElmt.appendChild( carouselControlsContainer );
			// Arrows
			const prevArrow = document.createElement( 'button' );
			prevArrow.setAttribute( 'type', 'button' );
			prevArrow.classList.add( 'carousel-prev' );
			prevArrow.dataset.bsTarget = '#' + carouselId;
			prevArrow.dataset.bsSlide = 'prev';
			prevArrow.innerHTML = '<i class="bi-chevron-left"></i>';
			const nextArrow = document.createElement( 'button' );
			nextArrow.setAttribute( 'type', 'button' );
			nextArrow.classList.add( 'carousel-next' );
			nextArrow.dataset.bsTarget = '#' + carouselId;
			nextArrow.dataset.bsSlide = 'next';
			nextArrow.innerHTML = '<i class="bi-chevron-right"></i>';
			carouselControlsContainer.appendChild( prevArrow );
			// Dots
			const carouselIndicators = document.createElement( 'div' );
			carouselIndicators.classList.add( 'carousel-indicators' );
			carouselControlsContainer.appendChild( carouselIndicators );
			items.forEach( ( carouselItem, i ) => {
				const itemIndicator = document.createElement( 'button' );
				itemIndicator.setAttribute( 'type', 'button' );
				itemIndicator.dataset.bsTarget = '#' + carouselId;
				itemIndicator.dataset.bsSlideTo = i;
				if ( i === 0 ) {
					itemIndicator.classList.add( 'active' );
				}
				carouselIndicators.appendChild( itemIndicator );
			} );
			carouselControlsContainer.appendChild( nextArrow );

			// Slides same height
			let maxHeight = 0;
			items.forEach( ( carouselItem ) => {
				const thisHeight = carouselItem.offsetHeight;
				if ( thisHeight > maxHeight ) {
					maxHeight = thisHeight;
				}
			} );
			items.forEach( ( carouselItem ) => {
				carouselItem.style.cssText = 'min-height: ' + maxHeight + 'px';
			} );

			const carouselOptions = {
				interval: false,
			};
			const thisCarousel = new bootstrap.Carousel( carouselElmt, carouselOptions );
			carouselCounter++;
		} );
	}
}